module.exports = __webpack_public_path__ + "/login_ui/img/gm-be06b8b7d2b38691c09294b3c9830b41.svg";